var map = {
	"./block.wav": 5250,
	"./buySell.wav": 5276,
	"./click.wav": 1814,
	"./click2.wav": 6524,
	"./click3.wav": 685,
	"./equip.wav": 7215,
	"./hit.wav": 8648,
	"./levelUp.wav": 1907,
	"./miss.wav": 7832,
	"./potion.wav": 9614
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6984;